import React from 'react';
import { FaPhoneAlt } from 'react-icons/fa';
import { CtaBar, CtaIcon, CtaLink } from './styles/MobileCallCta.styles';

const MobileCallCta = () => {
  return (
    <CtaBar role="complementary" aria-label="Call Fussaki Charters">
      <CtaLink href="tel:7142009815">
        <CtaIcon>{FaPhoneAlt({ size: 16 })}</CtaIcon>
        Call Now — Contact Our Crew
      </CtaLink>
    </CtaBar>
  );
};

export default MobileCallCta;
